import React, { useState } from 'react';
import GmModal from 'app/shared/modal/modal';
import { Button } from 'app/shared/button';
import { AIAssistantArea } from '..';
import styles from './launcher.module.css';

export const AIAssistantLauncher = () => {
  const [show_modal, setShowModal] = useState(false);

  return (
    <>
      <span className={styles.wrapper} data-tour="ai-assistant" title="AI Assistant">
        <Button icon_name="ai" className={styles.button} onClick={() => setShowModal(true)} />
      </span>
      <GmModal
        bodyClassName={styles.modal}
        title="AI Assistant"
        position="right"
        show_title
        show_modal={show_modal}
        onClose={() => setShowModal(false)}
      >
        <AIAssistantArea />
      </GmModal>
    </>
  );
};
